// Single source of truth for the public site navigation (header, mobile menu, footer).

export interface NavItem {
  labelKey: string
  to?: string
  href?: string
  children?: NavItem[]
}

export const headerNav: NavItem[] = [
  { labelKey: 'common:navHome', to: '/' },
  {
    labelKey: 'common:navGolfers',
    children: [
      { labelKey: 'common:navApp', to: '/app' },
      { labelKey: 'common:navPromo', to: '/promo' },
    ],
  },
  {
    labelKey: 'common:navGolfClub',
    children: [
      { labelKey: 'common:navSoftware', to: '/golf-club' },
      { labelKey: 'common:navPace', to: '/pace' },
      { labelKey: 'common:navPromo', to: '/promo' },
    ],
  },
  {
    labelKey: 'common:navBusiness',
    children: [
      { labelKey: 'common:navDevelopers', to: '/developers' },
      { labelKey: 'common:navPromo', to: '/promo' },
    ],
  },
  { labelKey: 'common:navBlog', to: '/blog' },
  { labelKey: 'common:navAbout', to: '/about-us' },
]

export interface FooterColumn {
  // Plain title (brand name) or i18n key — exactly one is set.
  title?: string
  titleKey?: string
  items: NavItem[]
}

export const footerColumns: FooterColumn[] = [
  {
    title: 'Pin Vision',
    items: [
      { labelKey: 'common:navHome', to: '/' },
      { labelKey: 'common:navAbout', to: '/about-us' },
      { labelKey: 'common:navBlog', to: '/blog' },
    ],
  },
  {
    titleKey: 'common:navSolutions',
    items: [
      { labelKey: 'common:navApp', to: '/app' },
      { labelKey: 'common:navSoftware', to: '/golf-club' },
      { labelKey: 'common:navPace', to: '/pace' },
      { labelKey: 'common:navDevelopers', to: '/developers' },
      { labelKey: 'common:navPromo', to: '/promo' },
    ],
  },
  {
    titleKey: 'common:footerResources',
    items: [
      { labelKey: 'common:navCookiePolicy', to: '/cookie-policy' },
      { labelKey: 'common:navApiLicense', to: '/api-license' },
      { labelKey: 'common:navPrivacyPolicy', to: '/privacy-policy' },
      { labelKey: 'common:navTermsConditions', to: '/terms-and-conditions' },
      { labelKey: 'common:navStatus', href: 'https://pinvision.betteruptime.com/' },
    ],
  },
]
